import {createSlice} from "@reduxjs/toolkit";

interface IInitState {
    addressId: number | null,
    address: string,
    addressComponent: string

}

const initialState: IInitState = {
    addressId: null,
    address: '',
    addressComponent: 'Календарь'
}

const headerReducer = createSlice({
    name: 'header',
    reducers: {
        setAddressId: (state, {payload}) => {
            state.addressId = payload
        },
        setAddress: (state, {payload}) => {
            state.address = payload
        },
        setAddressComponent: (state, {payload}) => {
            state.addressComponent = payload
        }
    },
    initialState,

})

export const {setAddressComponent, setAddressId, setAddress} = headerReducer.actions
export default headerReducer.reducer
